import { render, staticRenderFns } from "./BankingDetails.vue?vue&type=template&id=5d7ba44c&scoped=true"
import script from "./BankingDetails.vue?vue&type=script&lang=js"
export * from "./BankingDetails.vue?vue&type=script&lang=js"
import style0 from "./BankingDetails.vue?vue&type=style&index=0&id=5d7ba44c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7ba44c",
  null
  
)

export default component.exports